import * as React from 'react'

import { MortgageOffer } from 'embed/constants/models'

import MortgageOfferListItem from './ListItem'

export interface Props {
  mortgageOffers: MortgageOffer[]
  onMortgageOfferClick: (MortgageOffer) => void
}

const MortgageOfferList: React.FC<Props> = (props) => (
  <>
    {props.mortgageOffers.map((offer) => (
      <MortgageOfferListItem
        key={offer.uuid}
        onMortgageOfferClick={props.onMortgageOfferClick.bind(null, offer)}
        mortgageOffer={offer}
      />
    ))}
  </>
)

export default MortgageOfferList
